"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function roundRectDown(rect) {
    return {
        top: Math.floor(rect.top),
        left: Math.floor(rect.left),
        bottom: Math.floor(rect.bottom),
        right: Math.floor(rect.right),
    };
}
exports.roundRectDown = roundRectDown;
function checkVisiable(container, rect) {
    const width = rect.right - rect.left;
    const height = rect.bottom - rect.top;
    // console.log(width,height, container.bottom >= rect.top , container.top <= rect.bottom ,  container.right >= rect.left,  container.left <= rect.right);
    const _window = window;
    const paddingHeadHeight = _window.channelPageStore ? _window.channelPageStore.headHeight : 0;
    return width >= 0 &&
        height >= 0 &&
        container.bottom >= rect.top &&
        (container.top + paddingHeadHeight) <= rect.bottom &&
        container.right >= rect.left &&
        container.left <= rect.right;
}
exports.checkVisiable = checkVisiable;
class VisibilitySensor {
    constructor(hooks) {
        this.watchRunner = null;
        this.interValTimeout = null;
        this.isWatching = false;
        this.hooks = hooks;
    }
    watch() {
        if (this.isWatching) {
            return;
        }
        this.isWatching = true;
        let isRunCheck = false;
        let timeout = null;
        const run = () => {
            // 当在正文页里切换幽默社区H5频道列表的时候，window的scroll不可用
            // 但是当有导航栏时，还是会触发scroll方法，所以做一层兼容，使其不要清除interval
            if (scroll && !window.__scroll_is_unavailbale__) {
                clearInterval(this.interValTimeout);
            }
            timeout = setTimeout(() => {
                if (isRunCheck && timeout) {
                    clearTimeout(timeout);
                    return;
                }
                isRunCheck = true;
                this.check();
                isRunCheck = false;
            }, 100);
        };
        this.watchRunner = () => {
            run();
            scroll = true;
        };
        let scroll = false;
        window.addEventListener('scroll', this.watchRunner);
        this.interValTimeout = setInterval(run, 300);
        run();
    }
    addWatchElementScroll(el) {
        if (!el) {
            return;
        }
        el.addEventListener('scroll', this.watchRunner);
    }
    stopWatch() {
        this.isWatching = false;
        window.removeEventListener('scroll', this.watchRunner);
        this.interValTimeout && clearInterval(this.interValTimeout);
    }
    check() {
        const findElements = this.hooks.getCheckElements();
        const winRect = {
            top: 0,
            left: 0,
            bottom: window.innerHeight || document.documentElement.clientHeight,
            right: window.innerWidth || document.documentElement.clientWidth,
        };
        findElements.forEach((el, idx) => {
            if (!el) {
                return;
            }
            const rect = roundRectDown(el.getBoundingClientRect());
            const isVisible = this.hooks.checkVisiable ? this.hooks.checkVisiable(winRect, rect, el, idx) : checkVisiable(winRect, rect);
            this.hooks.onChange(isVisible, el);
        });
    }
    checkVisiable(el) {
        const rect = roundRectDown(el.getBoundingClientRect());
        const winRect = {
            top: 0,
            left: 0,
            bottom: window.innerHeight || document.documentElement.clientHeight,
            right: window.innerWidth || document.documentElement.clientWidth,
        };
        const isVisible = this.hooks.checkVisiable ? this.hooks.checkVisiable(winRect, rect, el) : checkVisiable(winRect, rect);
        this.hooks.onChange(isVisible, el);
        return isVisible;
    }
}
exports.default = VisibilitySensor;
//# sourceMappingURL=data:application/json;base64,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